import type { ITelemetryRegistry } from '../../types/types';
import { MetricType } from '../../types/types';

/**
 * The core telemetry registry: the single source of truth for the metrics and events
 * shared across every app. Consumed by the forwarder (label allowlist), the client emit
 * path + integrity tests, and the beacon ingest endpoints.
 * `app` and `environment` are implicit context labels applied by the pipeline — they must
 * NEVER appear in any metric's `labelKeys`.
 */
export const CoreTelemetryRegistry = {
  metrics: {
    app_error_total: { type: MetricType.COUNTER, labelKeys: [] },
    app_interaction_total: { type: MetricType.COUNTER, labelKeys: ['action'] },
    app_launch_total: { type: MetricType.COUNTER, labelKeys: [] },
    app_page_view_total: { type: MetricType.COUNTER, labelKeys: ['page'] },
    app_session_start_total: { type: MetricType.COUNTER, labelKeys: [] }
  },
  events: {
    'app.error.thrown': { fields: ['message', 'stack_hash', 'page'] },
    'site.cta.clicked': { fields: ['action', 'page'] },
    'site.session.ended': { fields: ['duration_seconds', 'pages_viewed'] },
    'site.session.started': { fields: ['referrer_domain', 'landing_page', 'user_agent_class'] }
  }
} satisfies ITelemetryRegistry;
